export enum SupplierRegistrationEvent {
    SUPPLIER_CREATED = 'SUPPLIER_CREATED',
    SUPPLIER_PRESENT = 'SUPPLIER_PRESENT',
    SUPPLIER_DATA_ENRICHED = 'SUPPLIER_DATA_ENRICHED',
    SUPPLIER_DATA_INCOMPLETE = 'SUPPLIER_DATA_INCOMPLETE',
    USER_CREATED = 'USER_CREATED',
    REGISTRATION_COMPLETED = 'REGISTRATION_COMPLETED',
    REGISTRATION_CANCELLED = 'REGISTRATION_CANCELLED',
    REGISTRATION_REJECTED = 'REGISTRATION_REJECTED',
}